var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import splitter from "json-string-splitter";
export function parseLog(raw) {
    try {
        var lines = raw.split('\n')
            .filter(function (line) { return !line.startsWith("@"); }); // csv headers
        return lines.map(tryParseJSON).map(fixUpLogJson);
    }
    catch (e) {
        console.log("falling back to json splitter");
        // the input might have had its data reformatted, breaking the original newline separated json
        var lines = splitter(raw).jsons;
        return lines.map(tryParseJSON).map(fixUpLogJson);
    }
}
function tryParseJSON(json) {
    try {
        return JSON.parse(json);
    }
    catch (e) {
        if (json.startsWith('"') && json.endsWith('"')) {
            try {
                var inner = json.substring(1, json.length - 1);
                // csv escaped quotes
                if (inner.startsWith('{""')) {
                    inner = inner.replace(/""/g, '"');
                }
                return JSON.parse(inner);
            }
            catch (e) {
                console.log(e);
            }
        }
        // fix unescaped message json
        var startPos = json.indexOf('"message":"') + ('"message":"').length;
        var endPos = json.lastIndexOf('","level":');
        var start = json.substring(0, startPos);
        var end = json.substring(endPos);
        var message = json.substring(startPos, endPos - startPos);
        var escapedMessage = message.replace(/([^\\]|^)["]/g, '$1\\"');
        json = start + escapedMessage + end;
        try {
            return JSON.parse(json);
        }
        catch (e) {
            console.error('Error while parsing log message:');
            throw e;
            // console.log(json);
            // console.error(e);
        }
    }
}
/**
 * attempt to fixup some mangling done by log aggregators to our json
 * to increase the number of times we can just copy-paste logs directly from users.
 */
function fixUpLogJson(message) {
    var _a, _b;
    if (((_a = message.content) === null || _a === void 0 ? void 0 : _a.message) && ((_b = message.content) === null || _b === void 0 ? void 0 : _b.attributes) && message.id && !message.reqId) {
        return __assign({ message: message.content.message }, message.content.attributes);
    }
    return message;
}
